
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bag",
      function () {
        return require("private-next-pages/bag/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bag"])
      });
    }
  